import BasePage from "./BasePage";

class BaseInputPage extends BasePage {
  onChangeTextInput = (e) => this.setState({ [e.target.name]: e.target.value });

  onChangeCheckField = (e) => {
    const current_value = this.state[e.target.name];
    this.setState({ [e.target.name]: !current_value });
  };

  onChangeInputFile = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
}

export default BaseInputPage;
